import { BuilderStoreContext } from '@builder.io/react'
import { useContext } from 'react'

import type { BuilderCategory } from '@/legacy/models'

export const useBuilderState = () => {
  const builderState = useContext(BuilderStoreContext)
  const lastUpdated = builderState.content?.lastUpdated || ''
  const author = builderState.content?.data?.author?.value?.data
  const builderPublicationDate = builderState.content?.createdDate
  const customPublication = builderState.content?.data?.customPublication
  const readingTime = builderState.content?.data?.customPublication?.readingTime
  const category = builderState.content?.data?.category?.value as BuilderCategory
  const path = builderState.content?.data?.url

  return {
    customPublication,
    lastUpdated,
    author,
    readingTime,
    category: category || null,
    builderPublicationDate,
    path,
  }
}
